import { useState, useCallback } from 'react';
import { useTracking } from 'react-tracking';
import { RouterLink } from '@redux-first-router-link';

import { Grid, Button } from '@simplywallst/ui-core';

import { ROUTE_PORTFOLIO_NEW } from '@/constants/routes';

import useUser from '@/hooks/useUser';

import { PortfolioOnboardingSlideShow } from '@/components/PortfolioOnboardingSlideShow';

export const PortfolioEmptyState = () => {
  const { trackEvent } = useTracking();

  const { data: user, mutate: mutateUser } = useUser();

  const [isOnboardingDismissed, setIsOnboardingDismissed] = useState(
    user.portfolio?.hasDismissedDashboardOnboarding
  );

  const handleDismiss = useCallback(() => {
    setIsOnboardingDismissed(true);
    mutateUser({
      settings: {
        portfolio: {
          has_dismissed_dashboard_onboarding: true,
        },
      },
    });
    trackEvent({
      type: 'track',
      subject: 'dismissDashboardPortfolioOnboarding',
      action: 'click',
    });
  }, [mutateUser, trackEvent]);

  if (isOnboardingDismissed) return null;

  return (
    <PortfolioOnboardingSlideShow
      footer={
        <Grid justifyContentMd="end">
          <RouterLink to={{ type: ROUTE_PORTFOLIO_NEW }}>
            <Grid>
              <Button styleType="louderLarge">Create my portfolio</Button>
            </Grid>
          </RouterLink>
        </Grid>
      }
      dismissOnboardingSlideshow={handleDismiss}
    />
  );
};
